import { FC } from 'react';

export const HighlightMatches: FC<{ text: string; query: string }> = ({ text, query }) => {
  const words = query
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

  if (words.length === 0) {
    return <>{text}</>;
  }

  const parts = text.split(new RegExp(`(${words.join('|')})`, 'gi'));

  return (
    <>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <mark key={index} style={{ padding: 0 }}>
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  );
};
